import { IFilterElement } from "@saleor/components/Filter";
import { findValueInEnum, maybe, parseBoolean } from "@saleor/misc";
import { SmopStatusEnum, TenantInput } from "@saleor/types/globalTypes";

import {
  createFilterTabUtils,
  createFilterUtils,
  getSingleEnumValueQueryParam
} from "../../../utils/filters";
import {
  StoreListUrlFiltersOpts,
  TenantFilterKeys
} from "../../components/StoreListPage/filters";
import {
  StoreListUrlFilters,
  StoreListUrlQueryParams,
  TenantListUrlFiltersEnum
} from "../../urls";
export const TENANT_FILTERS_KEY = "tenantFilters";

export function getFilterOpts(
  params: StoreListUrlFilters
): StoreListUrlFiltersOpts {
  return {
    status: {
      active: maybe(() => params.status !== undefined, false),
      value: maybe(() => findValueInEnum(params.status, SmopStatusEnum))
    }
  };
}

export function getFilterVariables(
  params: StoreListUrlFilters,
  paramsStatus
): TenantInput {
  if (paramsStatus) {
    return {
      isFeatured:
        params.isFeatured !== undefined
          ? parseBoolean(params.isFeatured, false)
          : undefined,
      search: params.query,
      status: paramsStatus
    };
  } else {
    return {
      isFeatured:
        params.isFeatured !== undefined
          ? parseBoolean(params.isFeatured, false)
          : undefined,
      search: params.query
    };
  }
}

export function getFilterQueryParam(
  filter: IFilterElement<TenantFilterKeys>
): StoreListUrlFilters {
  const { name } = filter;

  switch (name) {
    case TenantFilterKeys.status:
      return getSingleEnumValueQueryParam(
        filter,
        TenantListUrlFiltersEnum.status,
        SmopStatusEnum
      );
  }
}

export const {
  deleteFilterTab,
  getFilterTabs,
  saveFilterTab
} = createFilterTabUtils<StoreListUrlFilters>(TENANT_FILTERS_KEY);

export const { areFiltersApplied, getActiveFilters } = createFilterUtils<
  StoreListUrlQueryParams,
  StoreListUrlFilters
>(TenantListUrlFiltersEnum);
